<template>
    <div>
        <section class="composantsPickerWrapper filtersContainer">
            <div v-if="Object.keys(sections).length > 1">
                <h3 class="filterName">{{ $t("catalogue.filters.sections") }}</h3>
                <ul>
                    <li
                        v-for="section in sections"
                        :id="'typeOfSector' + section.id"
                        @click="$emit('updateQuery', { name: 'Catalog', query: getLinkParams({ section: section.id, offset: 1 }) });"
                        :class="['sectionType', 'pointer', { active: isElementActive(getRouteParams().section, section.id) }]"
                        :key="section.id"
                    >
                        {{ section.terms.name[$t("trad")] }}
                    </li>
                </ul>
            </div>
        </section>
        <section class="composantsPickerWrapper filtersContainer">
            <div v-if="Object.keys(status).length > 1">
                <h3 class="filterName">{{ $t("catalogue.filters.status") }}</h3>
                <ul>
                    <li
                        v-for="s in status"
                        :id="'typeOfSector' + s.id"
                        @click="$emit('updateQuery', { name: 'Catalog', query: getLinkParams({ status: s.id, offset: 1 }) });"
                        :class="['sectionType', 'pointer', { active: isElementActive(getRouteParams().status, s.id) }]"
                        :key="s.id"
                    >
                        {{ s.terms.name[$t("trad")] }}
                    </li>
                </ul>
            </div>
        </section>
        <section class="composantsPickerWrapper filtersContainer">
            <div>
                <h3 class="filterName">{{ $t("catalogue.filters.component") }}</h3>
                <ul>
                    <li
                        v-for="composant in types"
                        :id="'typeOfSector' + composant.id"
                        @click="$emit('updateQuery', { name: 'Catalog', query: getLinkParams({ type: composant.id }) });"
                        :class="['sectionType', 'pointer', { active: isElementActive(getRouteParams().type, composant.id) }]"
                        :key="composant.id"
                    >
                        {{ composant.terms.name[$t("trad")] }}
                    </li>
                </ul>
            </div>

            <div v-if="Object.keys(standDesigns).length > 1">
                <h3 class="filterName">{{ $t("catalogue.filters.standDesign") }}</h3>
                <ul>
                    <li
                        v-for="standDesign in standDesigns"
                        :id="'typeOfSector' + standDesign.id"
                        @click="$emit('updateQuery', { name: 'Catalog', query: getLinkParams({ standDesign: standDesign.id, offset: 1 }) });"
                        :class="['sectionType', 'pointer', { active: isElementActive(getRouteParams().standDesign, standDesign.id) }]"
                        :key="standDesign.id"
                    >
                        {{ standDesign.name }}
                    </li>
                </ul>
            </div>
            <div v-if="Object.keys(systemTypes).length > 1">
                <h3 class="filterName">{{ $t("catalogue.filters.systemType") }}</h3>
                <ul>
                    <li
                        v-for="systemType in systemTypes"
                        :id="'typeOfSector' + systemType.id"
                        @click="$emit('updateQuery', { name: 'Catalog', query: getLinkParams({ systemType: systemType.id, offset: 1 }) });"
                        :class="['sectionType', 'pointer', { active: isElementActive(getRouteParams().systemType, systemType.id) }]"
                        :key="systemType.id"
                    >
                        {{ systemType.terms.name[$t("trad")]["value"] }}
                    </li>
                </ul>
            </div>
            <div>
                <h3 class="filterName">{{ $t("catalogue.filters.starred") }}</h3>
                <ul class="starMenu">
                    <li
                        @click="$emit('updateQuery', { name: 'Catalog', query: getLinkParams({ star: 0 }) });"
                        :class="[{ active: getRouteParams().star === 0 }]"
                    >
                        {{ $t("menuCatalogStar.linkViewAll") }}
                    </li>

                    <li
                        @click="$emit('updateQuery', { name: 'Catalog', query: getLinkParams({ star: 1 }) });"
                        :class="[{ active: getRouteParams().star && getRouteParams().star === 1 }]"
                    >
                        {{ $t("menuCatalogStar.linkViewFeattured") }}
                    </li>
                </ul>
            </div>

            <div>
                <h3 class="filterName">{{ $t("catalogue.filters.published") }}</h3>
                <ul class="filterMenu">
                    <li
                        @click="$emit('updateQuery', { name: 'Catalog', query: getLinkParams({ notPublished: 1 }) });"
                        :class="[{ active: isElementActive(getRouteParams().notPublished, 1) }]"
                    >
                        {{ $t("product.notPublished") }}
                    </li>
                </ul>
            </div>
        </section>
        <section class="categoriesPickerWrapper filtersContainer">
            <div>
                <h3 class="filterName">{{ $t("catalogue.filters.categories") }}</h3>
                <div class="filterMenu">
                    <CategoryPicker
                        :categories="categories"
                        :getLinkParams="getLinkParams"
                        :getRouteParams="getRouteParams"
                        :hauteur="1"
                        :isActive="1"
                        @updateQuery="$emit('updateQuery', $event);"
                    ></CategoryPicker>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import CategoryPicker from "@/catalog/category-picker";
export default {
    name: "picker",
    props: ["getLinkParams", "getRouteParams", "categories", "systemTypes", "sections", "types", "standDesigns", "status"],
    data: () => ({}),
    methods: {
        isElementActive(element, id) {
            return element && parseInt(element) === id;
        }
    },
    components: { CategoryPicker }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";
.filtersContainer {
    & > div > h3 {
        @extend %second-text;
        vertical-align: middle;
        font-size: 11px;
        &::after {
            content: "";
            display: inline-block;
            width: 70%;
            height: 1px;
            background-color: #aaa;
            vertical-align: middle;
            text-align: right;
            float: right;
            margin: 10px 0 0 0px;
        }
    }
}
.starMenu,
#catalog {
    margin-top: 10px;
    .searchBar {
        @extend %primary-bloc;
        padding: 25px;
        border-radius: 3px;

        ul {
            padding: 10px;
            margin: 10px;
            @extend %second-background;

            li {
                list-style: none;
                padding: 5px;
                margin: 0;
                text-transform: uppercase;
                font-size: 1.6rem;
                color: #999;

                &:hover {
                    @extend %primary-text;
                    transition: 0.2s;
                }

                &.active {
                    color: deeppink;
                    font-weight: bold;
                    transition: all 0.3s;
                }
            }
        }
    }
}

.componentType {
    text-decoration: none;
}

.sectionType {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// picker.vue?98597162